/* kk-promo-deal.js — direct add-to-cart for the main-product `promo_deal` block.
   Same mechanism as the card direct-ATC in snippets/product-card.liquid: KK.cart.add (the only cart
   caller) with cart-drawer + header section re-render, then kk:drawer:open. Delegated on document. */
(function () {
  if (window.__kkPromoDealBound) return;
  window.__kkPromoDealBound = true;
  /* v4.37: line properties of the gift - _promo always, _set when the root carries data-deal-set (Flow order tag set-<flag>). */
  function dealProps(root) {
    var p = { _promo: 'gratis' }, f = root && root.getAttribute ? root.getAttribute('data-deal-set') : null;
    if (f) p._set = f;
    return p;
  }
  /* Promo variant display: when the variant picker hid a single-size tile and pre-checked its "2er Set"
     twin (data-promo-autoselect), fire a change so price / variant id / URL follow the visible tile. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.kk-vp__radio[data-promo-autoselect]:checked').forEach(function (r) {
      r.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  /* 2026-09-07: options carrying data-img (collection deals) swap the card image on change. */
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-deal-variant]') : null;
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var img = opt && opt.getAttribute('data-img');
    if (!img) return;
    var root = sel.closest('[data-deal-root]') || sel.closest('.s-pdp__deal');
    var el = root && root.querySelector('.s-pdp__deal-img, .kk-cart-gift__img');
    if (el) { el.removeAttribute('srcset'); el.src = img; }
  });
  /* 2026-09-07: on load, show the image of the pre-selected option (the card image is the deal product's photo,
     the first dropdown option may be another product) */
  function syncDealImage(sel) {
    var opt = sel.options[sel.selectedIndex]; var img = opt && opt.getAttribute('data-img'); if (!img) return;
    var root = sel.closest('[data-deal-root]') || sel.closest('.s-pdp__deal');
    var el = root && root.querySelector('.s-pdp__deal-img, .kk-cart-gift__img');
    if (el) { el.removeAttribute('srcset'); el.src = img; }
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-deal-variant]').forEach(syncDealImage);
  });
  var FALLBACK = 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
  function userMessage(err) {
    if (err && typeof err.userMessage === 'string' && err.userMessage) return err.userMessage;
    if (window.KK && window.KK.i18n && window.KK.i18n.cartAddError) return window.KK.i18n.cartAddError;
    return FALLBACK;
  }
  function setBusy(btn, on) {
    if (on) { btn.__kkPrev = btn.disabled; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    else { btn.disabled = !!btn.__kkPrev; btn.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-deal-atc]') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var root = btn.closest('[data-deal-root]') || btn.closest('.s-pdp__deal') || document;
    var select = root.querySelector('[data-deal-variant]');
    var region = root.querySelector('[data-deal-error]');
    var variantId = select ? Number(select.value) : 0;
    /* v4.52: data-deal-qty on the root = how many gift units one click adds (cart gift 2: both free pillows at once). */
    var dealQty = Math.max(1, Math.min(5, Number(root.getAttribute && root.getAttribute('data-deal-qty')) || 1));
    if (!variantId) return;
    if (!(window.KK && window.KK.cart)) {            // cart API not loaded → fall back to the product page
      var link = root.querySelector('.s-pdp__deal-link, .s-pdp__deal-media');
      if (link && link.href) window.location.href = link.href;
      return;
    }
    if (region) region.textContent = '';
    setBusy(btn, true);
    try {
      var sections = [];
      var drawer = document.querySelector('cart-drawer[data-section-id]');
      if (drawer) sections.push(drawer.getAttribute('data-section-id'));
      sections.push('header');
      /* 2026-09-04: data-deal-add-main = current product's variant id (kept in sync with the picker by the main
         form's hidden [name=id]); add it first, then the deal item, so "Topper + Gratis-Kissen" is one click. */
      var form = root.querySelector('[data-deal-form]');
      var mainId = 0;
      if (form && form.hasAttribute('data-deal-add-main')) {
        var mainForm = document.querySelector('form[action*="/cart/add"] [name="id"], [data-pdp-form] [name="id"]');
        mainId = Number((mainForm && mainForm.value) || form.getAttribute('data-deal-add-main')) || 0;
      }
      var first = mainId ? window.KK.cart.add({ id: mainId, quantity: 1 }, { sections: sections.join(',') }) : Promise.resolve();
      first
        .then(function () { /* v4.56b: data-deal-noprops (cart Topper-Set reminder) = paid add-on, no gift line properties, so it merges with
             the same variant already in the cart */
          var line = { id: variantId, quantity: dealQty };
          if (!(root.hasAttribute && root.hasAttribute('data-deal-noprops'))) line.properties = dealProps(root);
          return window.KK.cart.add(line, { sections: sections.join(',') }); })
        .then(function () {
          if (window.KK.pubsub) window.KK.pubsub.publish('kk:drawer:open', { id: 'cart' });
        })
        .catch(function (err) {
          if (region) region.textContent = userMessage(err);
          else console.warn('[kk] promo deal add-to-cart failed', err);
        })
        .finally(function () { setBusy(btn, false); });
    } catch (err) {
      setBusy(btn, false);
      if (region) region.textContent = userMessage(err);
      console.warn('[kk] promo deal add-to-cart could not be started', err);
    }
  });
})();

/* v4.54 (2026-10-16): set-tile "Im Set enthalten" popovers (.kk-st__tip, main-product set_tiles) are kept inside the
   viewport. On narrow Android screens the popover of the middle tile opened half off-screen. When a popover opens
   (tap on the i button, or hover), it is measured and shifted by --kk-tip-dx; the arrow is shifted back so it still
   points at the button. 8px gap to both screen edges, width capped at the screen width. */
(function () {
  if (window.__kkTipClamp) return; window.__kkTipClamp = true;
  var st = document.createElement('style');
  st.textContent = '.kk-st__tip{translate:var(--kk-tip-dx,0px) 0;max-width:calc(100vw - 16px);box-sizing:border-box}' +
    '.kk-st__tip::after{translate:calc(-1 * var(--kk-tip-dx,0px)) 0}';
  document.head.appendChild(st);
  function place(tp) {
    if (!tp) return;
    tp.style.setProperty('--kk-tip-dx', '0px');
    var r = tp.getBoundingClientRect();
    if (!r.width) return;
    var vw = document.documentElement.clientWidth || window.innerWidth, dx = 0;
    if (r.left < 8) dx = 8 - r.left;
    else if (r.right > vw - 8) dx = (vw - 8) - r.right;
    if (dx) tp.style.setProperty('--kk-tip-dx', Math.round(dx) + 'px');
  }
  function later(w) { var tp = w && w.querySelector('.kk-st__tip'); if (!tp) return; requestAnimationFrame(function () { place(tp); }); }
  document.addEventListener('click', function (e) { var w = e.target && e.target.closest ? e.target.closest('[data-st-tip]') : null; if (w) later(w); }, true);
  document.addEventListener('mouseover', function (e) { var w = e.target && e.target.closest ? e.target.closest('[data-st-tip]') : null; if (w) later(w); });
  window.addEventListener('resize', function () { document.querySelectorAll('.kk-st__tip.is-open').forEach(place); });
})();
